import client from "~/apis/client"

export function fetchCleanerNotes() {
  return client.get("/cleaner_notes")
}

export function resolveCleanerNote(id) {
  return client.patch(`/cleaner_notes/${id}/resolve`)
}
